// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"Profile__profileWrapper__3vFlN","reduceSpacing":"Profile__reduceSpacing__21lWs","leftColumn":"Profile__leftColumn__2LRBS"};